var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 80",
    style: {
      enableBackground: "new 0 0 130 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.8;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000121977692585737411890000016600880703547148418_);}\n\t\n\t\t.st2{opacity:0.675;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000058557703584452588810000012873508523930473134_);enable-background:new    ;}\n\t.st3{fill:url(#SVGID_00000146464154575434655010000000437012681950519734_);}\n\t.st4{fill:url(#SVGID_00000074436897114940234200000017546119539299693245_);}\n\t.st5{fill:url(#SVGID_00000016075385139262540630000018142605718948118204_);}\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.866 .364)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -180.0496,
    y1: 285.6697,
    x2: -180.0496,
    y2: 286.5921,
    gradientTransform: "matrix(116.1346 0 0 -49.5236 20975.998 14184.3281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEDEDE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9A9A9",
      stopOpacity: 0.3
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.9,14.9c1.3-4.2,2.6-6.8,3.7-7.8c3.2-2.8,7.5-1.3,8.4-1.1c3.3,0.8,2.2-4.4,5-5.4c1.9-0.7,3.4,0.2,4.6,2.6 c1.1-2.2,2.7-3.3,4.9-3.1c3.3,0.3,4.4,11.3,8.9,8.9c4.5-2.4,10-3,12.4,0.6c0.5,0.8,0.7-0.4,4.2-4.6c3.5-4.1,6.9-5.9,14-3.5 c3.2,1.1,5.9,4,7.9,8.9c0,6.9,5.1,10.9,15.2,12.2c15.2,1.9,3.4,18.2-15.2,23c-18.6,4.8-61.3,7.4-84.6-4.7 C1.9,32.8,5.4,24.1,27.9,14.9L27.9,14.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102523406658614086850000004531524169919962299_",
    gradientUnits: "userSpaceOnUse",
    x1: -178.3468,
    y1: 273.5045,
    x2: -178.3468,
    y2: 274.5045,
    gradientTransform: "matrix(55.974 0 0 -12.956 10048.7812 3619.1682)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#96A1C5",
      stopOpacity: 0.373
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000102523406658614086850000004531524169919962299_)"
    },
    cx: 66,
    cy: 69.2,
    rx: 28,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058553075347061077540000012756290783923376790_",
    gradientUnits: "userSpaceOnUse",
    x1: -180.2071,
    y1: 277.8802,
    x2: -180.2071,
    y2: 279.0769,
    gradientTransform: "matrix(128.9489 0 0 -17.7784 23304.0352 5019.604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#919191",
      stopOpacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.675,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000058553075347061077540000012756290783923376790_)",
      enableBackground: "new"
    },
    d: " M113.2,77.2c-21,5.3-92.9-0.8-100.5-3.5C9,72.4,5.7,69.9,2.7,66.2c-1-1.2-0.8-3,0.4-4c0.5-0.4,1.1-0.6,1.8-0.6h125.5 C133,68.5,127.3,73.7,113.2,77.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003826234205445450900000012768739631369333939_",
    gradientUnits: "userSpaceOnUse",
    x1: -177.394,
    y1: 279.15,
    x2: -177.394,
    y2: 278.7005,
    gradientTransform: "matrix(43.396 0 0 -18.196 7763.9673 5119.166)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-9,
    style: {
      stopColor: "#FF6A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6A72"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003826234205445450900000012768739631369333939_)"
    },
    d: "M87.5,51.8l-9.6-11.2 c-0.5-0.5-1.1-0.9-1.8-0.9H55.5c-0.7,0-1.4,0.3-1.8,0.9l-9.6,11.2v6.1h43.4C87.5,57.9,87.5,51.8,87.5,51.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119838926736927311340000016635311856875882128_",
    gradientUnits: "userSpaceOnUse",
    x1: -176.7883,
    y1: 276.4308,
    x2: -176.7883,
    y2: 277.4839,
    gradientTransform: "matrix(37.972 0 0 -15.8271 6778.7842 4438.6211)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7.991684e-8,
    style: {
      stopColor: "#FFBFC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFBFCB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119838926736927311340000016635311856875882128_)"
    },
    d: "M84.8,58.2l-8.4-9.7 c-0.4-0.5-1-0.7-1.6-0.7h-18c-0.6,0-1.2,0.3-1.6,0.7l-8.4,9.7v5.4h38C84.8,63.5,84.8,58.2,84.8,58.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027576421682821926320000005461674295959251375_",
    gradientUnits: "userSpaceOnUse",
    x1: -177.3941,
    y1: 277.5013,
    x2: -177.3941,
    y2: 276.5013,
    gradientTransform: "matrix(43.397 0 0 -15.912 7764.1489 4467.4731)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.385225e-7,
    style: {
      stopColor: "#FF2A30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD4DC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027576421682821926320000005461674295959251375_)"
    },
    d: "M87.5,65c0,0.9-0.4,1.6-1,2.1l-0.1,0.1 c-0.5,0.4-1.1,0.6-1.7,0.6H46.9c-0.3,0-0.7-0.1-1-0.2l-0.2-0.1c-1-0.4-1.7-1.5-1.7-2.6V51.9h10.5c1.2,0,2.1,1,2.1,2.1v0 c0,1.2,0.9,2.1,2.1,2.1h13.9c1.2,0,2.1-0.9,2.1-2.1c0-1.2,0.9-2.1,2.1-2.1h10.5L87.5,65z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.69ead2273faae1eec895a1da7eb62140.svg";
export { ForwardRef as ReactComponent };